import { formatInTimeZone } from 'date-fns-tz';
import parseISO from 'date-fns/parseISO';

import { isValidDate } from 'utils/date/isValidDate';
import { DATE_PATTERNS } from 'utils/date/datePatterns';

export function formatDate(
  date,
  pattern = 'full',
  timezone = 'America/Sao_Paulo'
) {
  if (!date) {
    return date;
  }

  const datePattern = DATE_PATTERNS.get(pattern) ?? pattern;
  const validDate = isValidDate(date) ? new Date(date) : parseISO(date);

  return formatInTimeZone(validDate, timezone, datePattern);
}
